var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-form",
    [
      _c("gg-text-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: _vm.rules.name,
            expression: "rules.name"
          }
        ],
        attrs: {
          label: "Name",
          name: "Name",
          placeholder: "Valid zone name",
          "error-messages": _vm.errors.collect("Name")
        },
        on: {
          input: _vm.sendData
        },
        model: {
          value: _vm.model.name,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "name", $$v)
          },
          expression: "model.name"
        }
      }),
      _c("gg-text-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: _vm.rules.ttl,
            expression: "rules.ttl"
          }
        ],
        attrs: {
          label: "TTL",
          name: "TTL",
          placeholder: "14400",
          "error-messages": _vm.errors.collect("TTL")
        },
        on: {
          input: _vm.sendData
        },
        model: {
          value: _vm.model.ttl,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "ttl", $$v)
          },
          expression: "model.ttl"
        }
      }),
      _c("gg-input-label", [_vm._v("Record")]),
      _c("v-textarea", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: _vm.rules.record,
            expression: "rules.record"
          }
        ],
        staticClass: "gg-input",
        attrs: {
          outlined: "",
          dense: "",
          name: "Record",
          rows: "3",
          placeholder: "Text",
          "error-messages": _vm.errors.collect("Record")
        },
        on: {
          input: _vm.sendData
        },
        model: {
          value: _vm.model.txtdata,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "txtdata", $$v)
          },
          expression: "model.txtdata"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }